import {
  ButtonERP,
  Dialog,
  DropdownPrimeReact,
  TagERP,
} from "@finanedi.es/storybook"
import { faDownload, faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import { postDeclaracionModelo303 } from "api/DeclaracionModelo"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import {
  TIPO_DECLARACION_DECLARACION_MODELO,
  TipoDeclaracionDeclaracionModelo,
} from "api/Types/TipoDeclaracionDeclaracionModeloEnum"
import { Dispatch, SetStateAction } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { frontendCurrency } from "utils/formatCurrency"
import {
  calculateCasilla71Resultado,
  DECLARACION_TYPE_ARRAY_FUNC,
  handleDownloadTxtModelo303,
} from "../DeclaracionModelo303/constants"

export const ModalPresentarModelo = ({
  showModalPresentar,
  setShowModalPresentar,
  watch,
  setValue,
}: {
  showModalPresentar: boolean
  setShowModalPresentar: Dispatch<SetStateAction<boolean>>
  watch: UseFormWatch<DeclaracionModelo303DtoProps>
  setValue: UseFormSetValue<DeclaracionModelo303DtoProps>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const { cuentaBancariaAll, cuentaBancariaAllIsLoading } =
    useCuentasBancariasAll({})

  const submitModelo = async (data: DeclaracionModelo303DtoProps) => {
    const response = await postDeclaracionModelo303({
      declaracionModelo303: data,
    })
    handleDownloadTxtModelo303(response)
  }
  return (
    <Dialog
      header={`${t("taxSummary.declaracion.modal.title")}`}
      headerClassName='!tw-text-lg'
      visible={showModalPresentar}
      onHide={() => setShowModalPresentar(!showModalPresentar)}
      maskClassName='!tw-p-6'
      className='!tw-mt-6 !tw-w-96'
      baseZIndex={30}
      draggable
    >
      <div className='tw-w-full tw-h-full tw-flex tw-gap-3 tw-flex-col tw-text-sm'>
        <div className='tw-rounded-md tw-bg-neutral-25 tw-h-10 tw-text-text tw-px-3 tw-gap-3 tw-flex tw-flex-row tw-justify-between tw-items-center'>
          <span className='tw-font-medium'>
            {t("taxSummary.declaracion.modal.resultado")}
          </span>
          <span>{frontendCurrency(calculateCasilla71Resultado(values))}</span>
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='!tw-text-xs tw-font-medium'>
            {t("taxSummary.declaracion.modal.modalidad")}
          </span>
          <DropdownPrimeReact
            options={DECLARACION_TYPE_ARRAY_FUNC(values, t)}
            optionValue='value'
            optionLabel='label'
            value={values.dp30301?.tipoDeclaracion}
            onChange={(e: {
              value: TipoDeclaracionDeclaracionModelo | null | undefined
            }) => {
              setValue("dp30301.tipoDeclaracion", e.value)
            }}
            pt={{
              input: {
                className: "!tw-text-sm ",
              },
            }}
            panelClassName='!tw-text-sm'
            className='tw-w-full'
            placeholder={`${t(
              "taxSummary.declaracion.modal.placeholderSelect"
            )}`}
          />
        </div>
        <TagERP
          color='info'
          icon={<FontAwesomeIcon icon={faInfoCircle} />}
          value={t("taxSummary.declaracion.modal.infoText")}
          className='!tw-rounded-md'
        />
        {values.dp30301?.tipoDeclaracion ===
          TIPO_DECLARACION_DECLARACION_MODELO.U && (
          <DropdownPrimeReact
            options={cuentaBancariaAll?.items ?? []}
            value={values.dp303Did?.iban}
            className='tw-w-full'
            optionValue='iban'
            optionLabel='iban'
            pt={{
              input: {
                className: "!tw-text-sm ",
              },
            }}
            panelClassName='!tw-text-sm'
            loading={cuentaBancariaAllIsLoading}
            placeholder={`${t("taxSummary.declaracion.modal.placeholderBank")}`}
            onChange={(e: { value: string }) => {
              setValue("dp303Did.iban", e.value)
            }}
          />
        )}
        <div className='tw-w full tw-flex tw-flex-row tw-justify-end'>
          <ButtonERP
            customize={{ type: "primary", size: "md" }}
            label={`${t("taxSummary.declaracion.modal.download")}`}
            onClick={() => submitModelo(values)}
            disabled={!values.dp30301?.tipoDeclaracion}
            icon={<FontAwesomeIcon icon={faDownload} />}
          />
        </div>
      </div>
    </Dialog>
  )
}
